"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("../palette/colors"));
const muiBadge = {
    styleOverrides: {
        colorPrimary: {
            backgroundColor: colors_1.default.burgundy,
            color: colors_1.default.beige,
        },
        badge: {
            marginTop: '2px',
            marginRight: '4px',
            maxWidth: '22px',
        },
    },
};
exports.default = muiBadge;
//# sourceMappingURL=muiBadge.js.map